"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconVolumeHigh = void 0;
var React = __importStar(require("react"));
var IconVolumeHigh = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M15.6381,14.9868 C15.3071,15.0608 15.0001,14.8068 15.0001,14.4658 L15.0001,9.5368 C15.0001,9.1958 15.3121,8.9418 15.6381,9.0108 C16.9821,9.3108 18.0001,10.5328 18.0001,11.9998 C18.0001,13.4658 16.9821,14.6868 15.6381,14.9868 Z M12.351,4.0835 C12.598,3.8905 13.004,4.0575 13,4.3275 L13,11.9765 L13,12.0575 L13,19.7045 C13,19.9765 12.594,20.0995 12.348,19.9055 L6,14.9995 L3,14.9995 C2.448,14.9995 2,14.5525 2,13.9995 L2,9.9995 C2,9.4475 2.448,8.9995 3,8.9995 L6,8.9995 L12.351,4.0835 Z M16.2909,4.0435 C19.6519,5.0665 21.9999,8.3395 21.9999,12.0025 C21.9999,15.6565 19.6589,18.9275 16.3069,19.9565 C16.2089,19.9865 16.1099,20.0005 16.0129,20.0005 C15.5849,20.0005 15.1889,19.7245 15.0569,19.2945 C14.8949,18.7665 15.1919,18.2065 15.7199,18.0445 C18.2399,17.2715 19.9999,14.7865 19.9999,12.0025 C19.9999,9.2115 18.2349,6.7265 15.7089,5.9575 C15.1809,5.7965 14.8819,5.2375 15.0429,4.7095 C15.2039,4.1805 15.7629,3.8855 16.2909,4.0435 Z" }))); };
exports.IconVolumeHigh = IconVolumeHigh;
exports.IconVolumeHigh.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconVolumeHigh;
